import React, { Fragment, FunctionComponent, useCallback, useState } from "react";
import styles from "./MobileMenu.module.scss";
import MobileMenuProps from "./MobileMenuProps.interface";

import { CLOSE_ALL_OVERLAYS, OPEN_MOBILE_MENU } from "layout/redux/overlay.actions";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import Anchor from "components/Anchor/Anchor";
import MenuLink, { SubMenuLink } from "blocks/models/menu-link.interface";
import IconViewer from "components/IconViewer/IconViewer";
import Dictionary from "components/Dictionary/Dictionary";

const MobileMenu: FunctionComponent<MobileMenuProps> = (props) => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings.content);

    const handleClick = () => {
        dispatch({
            type: CLOSE_ALL_OVERLAYS,
        });
    };

    const goBack = (menu?: MenuLink, subMenu?: SubMenuLink) => {
        dispatch({
            type: OPEN_MOBILE_MENU,
            menu: subMenu ? menu : undefined,
            subMenu: undefined
        });
    };

    const goForward = (event?: any, menu?: MenuLink, subMenu?: SubMenuLink) => {
        event?.preventDefault();

        dispatch({
            type: OPEN_MOBILE_MENU,
            menu: menu,
            subMenu: subMenu
        });
    };

    return (
        <Fragment>
            {/* Lock the scrollbar for the rest of the page on mobile, while drawer is open */}
            {/* TODO: Remember the scroll position and restore it when toggling locked state */}
            <Helmet bodyAttributes={{ class: "is-locked" }} />

            <nav className={styles.wrapper}>
                <div className={styles.inner}>
                    <div className={styles.content}>
                        {/* 1. level navigation */}
                        {!props.menu && !props.subMenu ? (
                            <nav className={styles.navigation}>
                                {settings?.menu && settings?.menu.map((firstItem, index) => {
                                    return (
                                        <div key={index} className={styles.nav_item}>
                                            {firstItem.content.subMenu && firstItem.content.subMenu.length > 0 ? (
                                                <button className={styles.next_level_button} onClick={event => goForward(event, firstItem)}>
                                                    {firstItem.content.label}
                                                </button>) : (
                                                <div onClick={handleClick}>
                                                    <Anchor to={firstItem.content.link} className={styles.first_link}>
                                                        {firstItem.content.label}
                                                    </Anchor>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </nav>
                        ) : null}

                        {/* 2. level navigation */}
                        {props.menu && !props.subMenu ? (
                            <Fragment>
                                <nav className={styles.navigation}>
                                    {props.menu ? (
                                        <Anchor className={styles.sub_heading_link} to={props.menu.content.link}>
                                            {props.menu.content.label}
                                            <IconViewer className={styles.sub_heading_icon} name="arrow-right" />
                                        </Anchor>
                                    ) : null}

                                    {props.menu?.content.subMenu && props.menu.content.subMenu.map((secondItem, index) => {
                                        return (
                                            <div key={index} className={styles.nav_sub_item}>
                                                <div onClick={handleClick}>
                                                    <Anchor to={secondItem.content.link} className={styles.link}>
                                                        {secondItem.content.label}
                                                    </Anchor>
                                                </div>

                                                {secondItem.content.subMenu && secondItem.content.subMenu.length > 0 ? (
                                                    <button className={styles.next_level_button} onClick={event => goForward(event, props.menu, secondItem)}>
                                                        <IconViewer name="arrow-right" aspectRatioX={1} aspectRatioY={1} />
                                                    </button>
                                                ) : null}
                                            </div>
                                        );
                                    })}

                                    <button className={styles.back_button} onClick={() => goBack(props.menu, props.subMenu)}>
                                        <IconViewer className={styles.icon} name="arrow-bottom-left" aspectRatioX={1} aspectRatioY={1} />
                                        <Dictionary name="NAVIGATION.BACK" />
                                    </button>
                                </nav>
                            </Fragment>
                        ) : null}
                    </div>
                </div>
            </nav>
        </Fragment>
    );
};

export default MobileMenu;